import React, { useState } from 'react'
import BackClose from './int_components/BackClose'
import Title from './int_components/Title'
import Form from './int_components/Form'
import Button, {BtnContainer} from './int_components/Button'
import spinner from './images/Spinner.png'
import privateIcon from './images/privateIcon.png'
import lockIcon from './images/lockIcon.png'
import shieldIcon from './images/shieldIcon.png'
import identityIcon from './images/identity@2x.png'
import phone from './images/phone.png'
import Loading from './int_components/Loading'
import accountsIcon from './images/accounts@2x.png'
import balancesIcon from './images/balances@2x.png'
import beneficiariesIcon from './images/beneficiaries.png'
import transactionsIcon from './images/transactions@2x.png'
import ConnectIllustration from './int_components/ConnectIllustration'
import RedirectIllustration from './int_components/RedirectIllustration'
import ConnectionSuccess from './int_components/ConnectionSuccess'
import PaymentSuccess from './int_components/PaymentSuccess'
import IconPlusText from './int_components/IconPlusText'
import BankList from './int_components/BankList'
import Accordion from './int_components/Accordion'
import LegalNotice from './int_components/LegalNotice'
import MockBank from './int_components/MockBank'

import {
    SDKContainer,
    Modal,
    Content,
    Load,
    Flex,
    PermissionsBar,
    PermissionsCant,
    Scroll,
    Panel,
    IconWrapper,
    ImageWrapper,
    Input,
    Pill,
    Link
} from './styles'
import accounts from '../../data/uae/accounts'


const LinkSDK = ({ 
    setIsActive, 
    isActive,
    selectedBank,
    setSelectedBank,
    applicationName,
    appIcon, 
    setConnected,
    sdkFlow,
    sdkPaymentState,
    setPaymentDone,
    updatePayments,
    country
}) => {
    const [ currentState, updateCurrentState ] = useState("LOADING")
    const [ otpValue, setOtpValue ] = useState("0000000")
    const [ isLoading, updateIsLoading ] = useState(false)

    const loadNextScreen = (newState) => {
        updateIsLoading(true)
        setTimeout(() => {
            updateIsLoading(false)
            updateCurrentState(newState)
        }, 2500)
    }

    function closeSDK() {
        updateCurrentState("LOADING")
        setIsActive(false)
    }

    function finishSDK() {
        updateCurrentState("LOADING")
        setIsActive(false)
        setConnected(true)
    }

    // Get value & account_id for payments
    const { value, account } = sdkPaymentState

    // Filter accounts from account_id
    const selectedAccount = accounts.filter(a => a.account_id === account)[0];

    // Native currency formatter
    const formatter = new Intl.NumberFormat('en-US', {
        style: "currency",
        currency: "USD",
    })

    const onSubmitValue = () => {
        // Update payments obj in App.js
        updatePayments(value, selectedAccount)
    }
    
    return (
        <SDKContainer isActive={isActive}>
            {currentState === "MOCKBANK" &&
                <MockBank setConnected={setConnected} closeSDK={closeSDK} selectedBank={selectedBank} />
            }
            {currentState !== "MOCKBANK" &&
                <Modal isActive={isActive}>
                    {currentState === "LOADING" && (
                        <Flex>
                            <BackClose clickClose={() => closeSDK()} />
                            <Title
                                title="Link your account"
                            />
                            <Loading />
                            {sdkFlow === "LINK" &&
                                <div style={{display: 'none'}}>{isActive && setTimeout(() => updateCurrentState("START"), 2000)}</div>
                            }
                            {sdkFlow === "PAY" &&
                                <div style={{display: 'none'}}>{isActive && setTimeout(() => updateCurrentState("INITIATE_PAYMENT"), 2000)}</div>
                            }
                        </Flex>
                    )}
                    {currentState === "START" && (
                        <Content>
                            <BackClose clickClose={() => closeSDK()} />
                            <Title 
                                title="Link your account"
                                subtitle={`${applicationName} uses Lean to connect to your bank account.`}
                            />
                            <ConnectIllustration applicationName={applicationName} appIcon={appIcon} />
                            <Scroll>
                                <IconPlusText
                                    icon={privateIcon}
                                    title="100% Private"
                                    text="Your credentials are never accessible to this or any other service."
                                />
                                <IconPlusText
                                    icon={lockIcon}
                                    title="Protected data"
                                    text="Your data is secured in transit using bank grade TLS 1.2 technology."
                                />
                                <div>
                                {country !== "SAU" &&
                                <IconPlusText
                                    icon={shieldIcon}
                                    title="Nationally regulated"
                                    text="Lean Technologies is regulated in the UAE by the ADGM Financial Services Regulatory Authority."
                                />
                                }
                                {country === "SAU" &&
                                <IconPlusText
                                    icon={shieldIcon}
                                    title="Nationally regulated"
                                    text="Lean Technologies is regulated in KSA by the Saudi Central Bank to operate in the Regulatory Sandbox."
                                />
                                }
                                </div>
                                
                                <LegalNotice Continue={"Continue"}/>
                            </Scroll>
                            <BtnContainer>
                                <Button onClick={() => updateCurrentState("BANKLIST")}>Continue</Button>
                            </BtnContainer>
                        </Content>
                    )}
                    {currentState === "BANKLIST" && (
                        <Flex>
                            <BackClose clickClose={() => closeSDK()} clickBack={updateCurrentState} previousState={"START"} />
                            <Title 
                                title="Select a bank"
                                subtitle={`Choose which bank to connect with ${applicationName}.`}
                            />
                            <BankList
                                updateCurrentState={updateCurrentState}
                                setSelectedBank={setSelectedBank}
                                country={country}
                            />
                        </Flex>
                    )}
                    {currentState === "PERMISSIONS" && (
                        <Content>
                            <BackClose clickClose={() => closeSDK()} clickBack={updateCurrentState} previousState={"BANKLIST"} />
                            <Title 
                                title="Permissions"
                                subtitle={`${applicationName} is requesting the following information from your bank account.`}
                            />
                            <PermissionsBar>
                                You can revoke or amend these permissions at any time
                            </PermissionsBar>
                            <Scroll>
                                <Accordion
                                    data={[
                                        {
                                            icon: identityIcon,
                                            title: "Verify your identity",
                                            text: `Allows ${applicationName} to view data such as name, addresses and phone numbers.`
                                        },
                                        {
                                            icon: accountsIcon,
                                            title: "View your accounts",
                                            text: `Allows ${applicationName} to receive account data such as a list of your accounts, account types and IBAN numbers.`
                                        },
                                        {
                                            icon: balancesIcon,
                                            title: "Available balances",
                                            text: `Allows ${applicationName} to view the balance of your associated accounts.`
                                        },
                                        {
                                            icon: transactionsIcon,
                                            title: "Transaction history",
                                            text: `Allows ${applicationName} to receive transaction history records.`
                                        },
                                        {
                                            icon: beneficiariesIcon,
                                            title: "Manage beneficiaries",
                                            text: `Allows ${applicationName} to add and update beneficiaries from your account(s).`
                                        }
                                    ]}
                                    
                                />
                                <PermissionsCant>
                                    <h3>{applicationName} cannot:</h3>
                                    <ul>
                                        <li>Make payments without your permission.</li>
                                        <li>View your bank username or password.</li>
                                        <li>Edit your account details.</li>
                                    </ul>
                                </PermissionsCant>
                                <LegalNotice Continue={"Continue"} />
                            </Scroll>
                            <BtnContainer>
                                {country === "SAU" &&
                                    <Button onClick={() => updateCurrentState("PREDIRECT")}>
                                        Allow
                                    </Button>
                                }
                                {country !== "SAU" &&
                                    <Button onClick={() => updateCurrentState("LOGIN")}>
                                        Allow
                                    </Button>
                                }
                            </BtnContainer>
                        </Content>
                    )}
                    {currentState === "LOGIN" && (
                        <Content>
                            <BackClose clickClose={() => closeSDK()} clickBack={updateCurrentState} previousState={"PERMISSIONS"} />
                            <Title 
                                title={selectedBank}
                                subtitle={`Enter your ${selectedBank} credentials.`}
                            />
                            <Form>
                                <label htmlFor="username">Username</label>
                                <input id="username" type="text" value="cloud@avalanche.net" disabled />
                                <label htmlFor="password">Password</label>
                                <input id="password" type="password" value="somevalue" disabled />
                            </Form>
                            <BtnContainer>
                                <Button onClick={() => loadNextScreen("SUCCESS")} isLoading={isLoading}>
                                    {!isLoading && <>Secure login</>}
                                    {isLoading && <Load src={spinner} />}
                                </Button>
                            </BtnContainer>
                        </Content>
                    )}
                    {currentState === "SUCCESS" && (
                        <Flex>
                            <BackClose clickClose={() => finishSDK()} />
                            <Title 
                                title={selectedBank}
                                subtitle=""
                            />
                            <ConnectionSuccess selectedBank={selectedBank} applicationName={applicationName} />
                            <BtnContainer>
                                <Button onClick={() => finishSDK()}>
                                    Done
                                </Button>
                            </BtnContainer>
                        </Flex>
                    )}
                    {currentState === "INITIATE_PAYMENT" && (
                        <Flex>
                            <BackClose clickClose={() => finishSDK()} />
                            <Title 
                                title={"Payment Details"}
                                subtitle="Please check the details below"
                            />
                            <Panel>
                                <div className="amount">
                                    <span className="currency">{selectedAccount.currency_code}</span>
                                    <span className="value">{selectedAccount && selectedAccount.currency_code === "AED" ?
                                        formatter.format(value.match(/\d+/g).join('').replace(',','')).replace(/\$/i, "").trim() :
                                        formatter.format(value.match(/\d+/g).join('').replace(',',''))}
                                    </span>
                                </div>
                                <div>
                                    <div className="text"></div>
                                    <div className="text">{selectedBank} - {selectedAccount.name}</div>
                                </div>
                            </Panel>
                            <IconWrapper>
                                ↓
                            </IconWrapper>
                            <Panel>
                                <img alt="clientLogo" src={appIcon} className="clientLogo"/> 
                                <div className="text">Paying to {applicationName}</div>
                            </Panel>
                            <BtnContainer>
                                <Button onClick={() => loadNextScreen("AUTHORIZE_PAYMENT")} isLoading={isLoading}>
                                    {!isLoading && <>Confirm payment</>}
                                    {isLoading && <Load src={spinner} />}
                                </Button>
                            </BtnContainer>
                            <LegalNotice Continue={"Confirm payment"}/>
                        </Flex>
                    )}
                    {currentState === "AUTHORIZE_PAYMENT" && (
                        <Flex>
                            <BackClose clickClose={() => finishSDK()} />
                            <Title 
                                title={"Authorize this payment"}
                                subtitle={`Enter the One Time Password sent from ${applicationName} to your registered device`}
                            />
                            <Input placeholder="000000" value={otpValue} onChange={(e)=> setOtpValue(e.target.value)} onFocus={() => {setOtpValue('')}}/>
                            <Pill>Make sure the code isn’t expiring soon.</Pill>
                            <IconWrapper>
                                ↑
                            </IconWrapper>
                            <ImageWrapper>
                                <img alt="phone" src={phone}/>
                            </ImageWrapper>
                            <Link color="#B5B5B5" size="12px" href="https://leantech.me">How to get your One Time Password?</Link>
                            <BtnContainer>
                                <Button onClick={() => loadNextScreen("SUCCESS_PAYMENT")} isLoading={isLoading}>
                                    {!isLoading && <>Submit</>}
                                    {isLoading && <Load src={spinner} />}
                                </Button>
                            </BtnContainer>
                        </Flex>
                    )}
                    {currentState === "SUCCESS_PAYMENT" && (
                        <Flex>
                            <BackClose clickClose={() => finishSDK()} />
                            <Title 
                                title={selectedBank}
                                subtitle=""
                            />
                            {value && account && <PaymentSuccess value={value} account={account} applicationName={applicationName} />}
                            <BtnContainer>
                                <Button onClick={() => {
                                    finishSDK();
                                    setPaymentDone(true)
                                    onSubmitValue()
                                }}>
                                    Done
                                </Button>
                            </BtnContainer>
                        </Flex>
                    )}
                    {currentState === "PREDIRECT" && (
                        <Content>
                        <BackClose clickClose={() => closeSDK()} clickBack={updateCurrentState} previousState={"PERMISSIONS"} />
                        <Title 
                            title={`Connect with ${selectedBank}`}
                            subtitle={""}
                        />
                        <div style={{marginTop: "70px"}}>
                            <RedirectIllustration applicationName={applicationName} appIcon={appIcon} />
                            <p style={{textAlign: 'center'}}>You will now be redirected to {selectedBank} to grant permissions for {applicationName} to access your account data.</p>
                        </div>
                        <BtnContainer>
                            <Button onClick={() => loadNextScreen("MOCKBANK")} isLoading={isLoading}>
                                {!isLoading && <>Continue to {selectedBank}</>}
                                {isLoading && <><Load src={spinner} /> Redirecting</>}
                            </Button>
                        </BtnContainer>
                    </Content>
                    )}
                </Modal>
            }
        </SDKContainer>
    )
}

export default LinkSDK
